import { callApiToServer } from "../callApi";

export async function deleteRedeemVoucher(authtoken, searchText, voucherId) {
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authtoken,
    };

    let body = JSON.stringify({
      search_text: searchText,
      voucherId: voucherId,
    });

    let endUrl = "v1/auth/voucher-inventory";

    let responseData = await callApiToServer(body, header, "DELETE", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
